export default __webpack_public_path__ + "static/media/PHY967-min.9bf4e611.jpeg";